import React from 'react';
import { connect } from 'react-redux';

import ArtisanList from '../../List/Artisan/ArtisanList';
import { List as listData } from '../../../utils/List/ListeArtisans';

const { dataFormat, actions, menu } = listData.default;

const mapStateToProps = ({
  dialog: {
    contentProps: {
      filter,
      sort = { _id: -1 },
      count = 20,
    },
  },
}) => ({
  filter,
  sort,
  count,
});

const ArtisanListDialog = ({ filter, sort, count }) => (
  <ArtisanList
    filter={filter}
    sort={sort}
    count={count}
    list={dataFormat}
    actions={actions}
    menu={menu}
    filterName="default"
    filteredByColumn={false}
  />
);

export default connect(mapStateToProps)(ArtisanListDialog);
